import api from "./index";

// Pagination payload & helper
export interface UserPaginationPayload {
    curPage: number;
    perPage: number;
    sortBy: string;
    direction: "asc" | "desc" | string;
    whereClause: Array<{ key: string; value: string; operator: string }>;
}

export interface UpdateUserStatusPayload {
    userId: string;
    isActive: boolean;
}

export const paginateUsers = async (
    payload: UserPaginationPayload
) => {
    return api.post("/user/pagination", payload);
};

export const updateUserStatus = async (
    payload: UpdateUserStatusPayload
) => {
    return api.post("/user/update-status", payload);
};